import PropTypes from 'prop-types';
import styled from 'styled-components';


const TileWrapper = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-decoration: none;
  border: 2px solid ${({ theme }) => theme.colors.shades[6]};
  padding-top: 10px;
  padding-bottom: 5px;
`;

const TileImg = styled.img`
  max-width: 80px;
`;

const TileLabel = styled.div`
  margin-top: 10px;
  color: ${({ theme }) => theme.colors.link.default};
  text-align: center;
  font-weight: bold;
  font-size: 14px;
`;


const CategoryLinkTile = ({
  link, image, label, className
}) => (
  <TileWrapper href={link} className={className}>
    <TileImg src={image} alt={label} />
    <TileLabel>{label}</TileLabel>
  </TileWrapper>
);

CategoryLinkTile.propTypes = {
  link: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string
};

CategoryLinkTile.defaultProps = {
  className: ''
};

export default CategoryLinkTile;
